/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// components
import Toaster from 'material/message/toaster/toaster_container';
import Notification from 'material/message/notification/notification_container';
// utils

// styles
import injectSheet from 'react-jss';
import styles from 'material/structure/messageholder/messageholder_styles';



/* ========== ~~~~~~~~~~ STRUCTURE : MESSAGE HOLDER : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class MessageHolder extends Component {
    _renderTopToasters = () => this.props.toasters.top.map(message => <Toaster key={message.id} message={message} />);
    _renderBottomToasters = () => this.props.toasters.bottom.map(message => <Toaster key={message.id} message={message} />);
    _renderTopNotifications = () => this.props.notifications.top.map(message => <Notification key={message.id} message={message} />);
    _renderBottomNotifications = () => this.props.notifications.bottom.map(message => <Notification key={message.id} message={message} />);
    render() {
        return (
            <div id={`messageholder`} className={`structure messageholder ${this.props.classes.messageHolder}`}>
                <div className={`messages top`}>
                    {this._renderTopNotifications()}
                    {this._renderTopToasters()}
                </div>
                <div className={`messages bottom`}>
                    {this._renderBottomNotifications()}
                    {this._renderBottomToasters()}
                </div>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(MessageHolder);
